let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lONtZ")).then(() => parcelRequire('2v6nj'));